import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Tooltip, Typography } from '@material-ui/core';
import Descriptions from './desciption';
import { convertDatetoDateFormatted } from '../../utilitys/date';
import { getUrl } from '../../utilitys/url';
import { useTranslation } from 'react-i18next';
import { AdsOfficeDto } from '../../dto/adsOffice';

interface IAdsProps {
  ads: AdsOfficeDto[];
}

const Panel = ({ ads: ads }: IAdsProps) => {
  const { t } = useTranslation();

  const onDownloadPdf = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div className="mt-3 w-full">
      {ads.map((p) => (
        <Accordion key={p.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel1bh-content${p.id}`}
            id={`panel1bh-header${p.id}`}
          >
            <div className='w-full flex justify-between '>
              <div className='font-bold text-xl w-full text-center font-body'>
                {p.title}
              </div>
              {p.documentUrl && (
                <Tooltip
                  title={
                    <Typography variant='body2'>
                      {t('pages.adsOffice.tooltipPdf')}
                    </Typography>
                  }
                  placement='top'
                >
                  <div
                    className='space-x-3 flex text-red-700'
                    onClick={() => onDownloadPdf(getUrl(p.documentUrl))}
                  >
                    <PictureAsPdfIcon fontSize='large' />
                  </div>
                </Tooltip>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className='mt-1 w-full flex flex-col p-20 pt-0 font-body'>
            <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelSecretaryEntityName')}
              </span>
              <span className='text-lg'>{p.secretaryEntityName || 'N/A'}</span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelValidity')}
              </span>
              <span className='text-lg'>{p.validity || 'N/A'}</span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelType')}:
              </span>
              <span className='text-lg'>{p.type}</span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelExpeditionDate')}
              </span>
              <span className='text-lg'>
                {convertDatetoDateFormatted(p.expeditionDate)}
              </span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelPublicationDate')}
              </span>
              <span className='text-lg'>
                {convertDatetoDateFormatted(p.publicationDate)}
              </span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelName')}
              </span>
              <span className='text-lg'>{p.title}</span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelSubject')}
              </span>
              <span className='text-lg'>{p.subject}</span>
              <span className='text-lg font-bold mt-3'>
                {t('pages.adsOffice.labelDescription')}
              </span>
              <Descriptions
                description1={p.paragraph1}
                description2={p.paragraph2}
                description3={p.paragraph3}
                description4={p.paragraph4}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
export default Panel;
